<template>
  <div>

    <pageTable ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               tableApi="admin/system/admin_user/getAdminUser"
    >
      <template v-slot:searchFormItem>
        <FormItem prop="account">
          <Input type="text" v-model="searchData.account" placeholder="账号或昵称" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="group_id">
          <Select v-model="searchData.group_id" class="lx-search-item" placeholder="请选择角色">
            <Option v-for="(item,key) in groups" :value="item.id" :key="key">{{ item.name }}</Option>
          </Select>
        </FormItem>
      </template>

      <template v-slot:otherBtn>
        <FormItem>
          <Button type="primary" @click="edit(0 , 'add')">添加</Button>
        </FormItem>
      </template>
    </pageTable>

    <user-edit v-if="showEditUser"
            :show-edit-user="showEditUser"
            :groups="groups"
               :companys="companys"
            :user-id="editUserId"
            ref="userEdit"
            @cancel-edit="cancelEdit"
            @edit-success="editSuccess"
    >
    </user-edit>

  </div>
</template>

<script>
  import userEdit from "./user-edit";
  import pageTable from "@/components/table/pageTable";
  export default {
    name: "user-lists",
    components:{userEdit,pageTable},
    data() {
      return {
        showEditUser:false,
        editUserId:0,     //编辑的用户ID
        searchData: {
          account: '',
          group_id:''
        },
        tableColumn: [
          {title: '编号',key: 'uid'},
          {title: '账号',key: 'account'},
          {title: '所属',key: 'company_name'},
          {title: '姓名',key: 'name'},
          {title: '角色',key: 'group_name'},
          {title: '上次登录时间',key: 'last_login_time'},
          {title: '创建时间',key: 'create_time'},
          {title: '状态',key: 'status',render:(h,params)=>{
            let status = parseInt(params.row.status)
            return h('Tag',{
              props:{
                size: 'medium',
                color: status===1 ? 'default' : 'error'
              }
            },status===1 ? '正常' : '已禁用')
            }},
          {title: '操作',render:(h,params)=>{
            return h('div',[
              h('Button',{
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.edit(params.row.uid , 'view')
                  }
                }
              },'查看'),
              h('Button',{
                props: {
                  type: 'error',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.disable(params.row.uid)
                  }
                }
              },'禁用'),
            ])
            }},
        ],
        tableData: [],
        groups:[],    //角色列表
        companys:[],
        hasPerminssion:false,  //是否有权限
      }
    },
    methods: {
      async initPage(){
        let res = await this.$commonFun.postProxy('admin/common/getPageInitInfo',{type:['groups','companys']})
        this.groups = res.data.groups
        this.companys = res.data.companys
      },
      resetSearchForm(){
        this.$refs.searchForm.resetFields()
        this.getLists()
      },
      async getLists(){
        let res = await this.$commonFun.postProxy('admin/system/admin_user/getAdminUser',this.searchData)
        this.tableData = res.data
      },
      cancelEdit(){
        this.showEditUser = false
      },
      edit(id , event){
        if( event !== 'view' && !this.hasPerminssion){
          this.$Message.warning('您没有操作权限，请联系管理员')
          return
        }
        this.showEditUser = true
        this.editUserId = id || 0
      },
      editSuccess(){
        this.getLists()
        this.showEditUser = false
      },
      checkPermission(api){
        this.$commonFun.postProxy(api).then(res=>{
          this.hasPerminssion = res.data.hasPermission
        })
      },

      disable(id){
        if(!this.hasPerminssion){
          this.$Message.warning('您没有操作权限，请联系管理员')
          return
        }
        this.$Modal.confirm({
          title: '提示',
          content: '<p>确定要禁用该用户吗？</p>',
          onOk: async () => {
            let res = await this.$commonFun.postProxy('admin/system/admin_user/disableUser',{uid:id})
            if(res.code === 200){
              this.$Message.success('操作成功')
              this.getLists()
            }else{
              this.$Message.error(res.msg || '操作失败')
            }
          },
          onCancel: () => {
            //console.log('点击了取消')
          }
        })
      }
    },
    mounted() {
      this.initPage()
      this.getLists()
      this.checkPermission('admin/system/admin_user/getUserPermission')
    },

  }
</script>

<style scoped>

</style>
